(function () {
  'use strict';

  if (typeof window === 'undefined' || !window.webVitals) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var RUM_ENDPOINT = 'https://www.tittaniumdash.com.br/api/rum/web-vitals';
  var CLIENT_SLUG  = 'relaxmedic';
  var SAMPLE_RATE  = 0.05;

  if (Math.random() > SAMPLE_RATE) return;

  var SENSITIVE_PARAMS = [
    'email', 'phone', 'token', 'checkout', 'customer',
    'auth', 'password', 'session', 'sid', 'access_token',
    'id_token', 'cpf', 'cnpj', 'utm_term'
  ];

  function sanitizeUrl() {
    try {
      var u = new URL(window.location.href);
      SENSITIVE_PARAMS.forEach(function (p) { u.searchParams.delete(p); });
      return u.origin + u.pathname;
    } catch (e) {
      return window.location.origin + window.location.pathname;
    }
  }

  function getDeviceType() {
    var w = window.innerWidth || document.documentElement.clientWidth || 0;
    if (w <= 767) return 'mobile';
    if (w <= 1024) return 'tablet';
    return 'desktop';
  }

  function getConnection() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    return {
      type: c && c.type ? String(c.type) : null,
      effective: c && c.effectiveType ? String(c.effectiveType) : null
    };
  }

  var sentIds = Object.create(null);

  function send(metric) {
    if (!metric || !metric.id) return;
    if (sentIds[metric.id + ':' + metric.value]) return;
    sentIds[metric.id + ':' + metric.value] = 1;

    var conn = getConnection();
    var payload = {
      client_slug: CLIENT_SLUG,
      site_origin: window.location.origin,
      url: sanitizeUrl(),
      pathname: window.location.pathname,
      metric_name: metric.name,
      metric_value: typeof metric.value === 'number' ? metric.value : null,
      rating: metric.rating || null,
      delta: typeof metric.delta === 'number' ? metric.delta : null,
      id: metric.id,
      navigation_type: metric.navigationType || null,
      device_type: getDeviceType(),
      connection_type: conn.type,
      effective_connection_type: conn.effective,
      user_agent: navigator.userAgent,
      viewport_width: window.innerWidth,
      viewport_height: window.innerHeight,
      timestamp: new Date().toISOString()
    };

    var body = JSON.stringify(payload);

    try {
      if (navigator.sendBeacon) {
        var blob = new Blob([body], { type: 'application/json' });
        if (navigator.sendBeacon(RUM_ENDPOINT, blob)) return;
      }
    } catch (e) {}

    try {
      fetch(RUM_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body,
        keepalive: true,
        mode: 'cors',
        credentials: 'omit'
      }).catch(function () {});
    } catch (e) {}
  }

  var wv = window.webVitals;
  if (wv.onLCP)  wv.onLCP(send, { reportAllChanges: true });
  if (wv.onCLS)  wv.onCLS(send, { reportAllChanges: true });
  if (wv.onINP)  wv.onINP(send, { reportAllChanges: true });
  if (wv.onFCP)  wv.onFCP(send);
  if (wv.onTTFB) wv.onTTFB(send);
})();
